/* Arcana — track and render recently viewed products
   Loads the theme's reduced product-card view without exposing internal fields.
*/
(function () {
  'use strict';

  const KEY = 'arcana_recently_viewed';
  const MAX = 12;
  const SHOW = 4;

  const get = () => {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; }
    catch { return []; }
  };
  const set = (list) => {
    try { localStorage.setItem(KEY, JSON.stringify(list)); }
    catch { /* silent */ }
  };

  // 1. Track current product
  const handle = document.body.dataset.productHandle;
  if (handle) {
    let list = get().filter((h) => h !== handle);
    list.unshift(handle);
    if (list.length > MAX) list = list.slice(0, MAX);
    set(list);
  }

  // 2. Render strip if container present on page
  const container = document.querySelector('[data-arcana-recently-viewed]');
  if (!container) return;

  const list = get().filter((h) => h !== handle).slice(0, SHOW);
  if (list.length === 0) {
    container.style.display = 'none';
    return;
  }

  const root = window.Shopify?.routes?.root || '/';

  Promise.all(
    list.map((h) =>
      fetch(`${root}products/${encodeURIComponent(h)}?view=recently-viewed-card`)
        .then((r) => (r.ok ? r.text() : null))
        .then((markup) => {
          if (!markup) return null;
          const parsedDocument = new DOMParser().parseFromString(markup, 'text/html');
          return parsedDocument.querySelector('[data-arcana-recently-viewed-card]');
        })
        .catch(() => null)
    )
  ).then((cards) => {
    const grid = container.querySelector('[data-arcana-recently-viewed-grid]');
    if (!grid) return;
    const valid = cards.filter(Boolean);
    if (valid.length === 0) {
      container.style.display = 'none';
      return;
    }

    grid.textContent = '';
    valid.forEach((card) => grid.appendChild(card));
    container.classList.add('is-ready');
  });
})();
